import { graphql, useStaticQuery } from 'gatsby';

export const useFooterBusinessContactData = () => {
  const data = useStaticQuery(graphql`
    query {
      footerBusinessContactDataJson {
        phone {
          link_text
          link_to
        }
        contact_links {
          link_text
          link_to
        }
        social_links {
          link_text
          link_to
        }
      }
    }
  `);

  return data.footerBusinessContactDataJson;
};
